import { render, staticRenderFns } from "./CPF.vue?vue&type=template&id=636479cc&scoped=true&"
import script from "./CPF.vue?vue&type=script&lang=js&"
export * from "./CPF.vue?vue&type=script&lang=js&"
import style0 from "./CPF.vue?vue&type=style&index=0&id=636479cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636479cc",
  null
  
)

export default component.exports